import {LocalizationProvider} from '@mui/x-date-pickers';
import 'dayjs/locale/nb';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import useLanguage from 'hooks/useLanguage';

export const LocalizationComponent = ({children}) => {
  const {datefnsLocale} = useLanguage();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={datefnsLocale}>
      {children}
    </LocalizationProvider>
  );
};
